module.exports = __webpack_public_path__ + "static/media/sin_pagos.e10d54c8.svg";